import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import UsersTable from './UsersTable';
import { Link } from 'react-router-dom';

const Users = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Users" title="Users" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Users</H5>
                <Link to="/users/new">
                  <Btn color="primary">New user</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <UsersTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Users;
